import React from 'react';

const EmptyStateChart = ({ message = 'No hay datos para mostrar', height = 140 }) => (
  <div className="d-flex flex-column align-items-center justify-content-center text-center" style={{ minHeight: height }}>
    <i className="fa fa-chart-bar" style={{ fontSize: 32, color: '#C0C0C0' }}></i>
    <p className="font-lato-normal-400 mb-0 mt-2" style={{ fontSize: 14, color: '#5B5B5B' }}>
      {message}
    </p>
  </div>
);

export default EmptyStateChart;
